import { DomainService } from './DomainService';
const baseUrl = DomainService.GetBaseUrl() + "Event/";

const AddOrUpdateEvent = async (formData) => {

    try {
        const res = await fetch(baseUrl + "AddOrUpdateEvent", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        const data = await res.json();
        return data;
    } catch (error) {
    }
}
const GetEventList = async (formData) => {
    const res = await fetch(baseUrl + "GetEventList", {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    });
    const data = await res.json();
    return data;
}
const GetEventListById = async (id) => {
    const res = await fetch(baseUrl + "GetEventsByID?eventID="+id, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
export default Event = {
    AddOrUpdateEvent,
    GetEventList,
    GetEventListById
};
